import 'react-dates/initialize';
import React from 'react';  
import { Provider } from 'react-redux'
//import { createStore, combineReducers } from 'redux'
import Main from '../main/Main.jsx';
//import {app, user, menu, logging, period } from '../main/reducers.jsx'
import { ACT_FN_DISPATCH } from '../main/actions.js';
import $ from 'jquery'
import { store } from '../main/Store.jsx';

/*

const rootReducer = combineReducers({app, user,  menu, logging, period})

class StateLoader {

    loadState() {
        try {
			//return this.initializeState();
            let serializedState = localStorage.getItem("webloggerstate");

            if (serializedState === null) {
                return this.initializeState();
            }

            return JSON.parse(serializedState);
        }
        catch (err) {
            return this.initializeState();
        }
    }

    saveState(state) {
        try {
            let serializedState = JSON.stringify(state);
            localStorage.setItem("webloggerstate", serializedState);

        }
        catch (err) {
        }
    }

    initializeState() {
        return {
            //state object
        }
    };
}
*/

class App extends React.Component { 

    constructor(props/*, store*/) {
        super(props);
        /*this.stateLoader = new StateLoader();
        this.store = createStore(rootReducer, this.stateLoader.loadState())
        this.store.subscribe(() => { this.stateLoader.saveState(this.store.getState()) })*/
        /*this.*/store.dispatch({type:ACT_FN_DISPATCH, fn: /*this.*/store.dispatch})
        this.state = {config:undefined}
    }

    componentDidMount() {
        $.ajaxSetup({ cache: false })
        $.get('/config.json')
            .then((config) => {
                this.setState({config})
            })
            .catch((err) => {
                console.log("Could not get config")
                this.setState({ config: { webloggerapi:""} })
            })
    }

    render() {  
        var main
        if (this.state.config !== undefined) {
            main = <Main cfg={this.state.config}/>
        }
    	return (  
           <Provider store={/*this.*/store}>
                {main}
           </Provider>
      );  
   }  
}  
  
export default App;  